module.exports = "data:image/jpeg;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAic3RhdGljL2ltYWdlcy9mYWNlYm9vay1pY29uLmpwZyI7"